import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition } from './../../../wayfinder'
import enroll47ba96 from './enroll'
import challengeF9272e from './challenge'
import recoveryA63da9 from './recovery'
/**
* @see \App\Domain\OrganizationAccess\Presentation\Http\Controllers\OrgMfaEnrollmentController::enroll
* @see app/Domain/OrganizationAccess/Presentation/Http/Controllers/OrgMfaEnrollmentController.php:21
* @route 'https://org.proexpert.app/org/mfa/enroll'
*/
export const enroll = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: enroll.url(options),
    method: 'get',
})

enroll.definition = {
    methods: ["get","head"],
    url: 'https://org.proexpert.app/org/mfa/enroll',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Domain\OrganizationAccess\Presentation\Http\Controllers\OrgMfaEnrollmentController::enroll
* @see app/Domain/OrganizationAccess/Presentation/Http/Controllers/OrgMfaEnrollmentController.php:21
* @route 'https://org.proexpert.app/org/mfa/enroll'
*/
enroll.url = (options?: RouteQueryOptions) => {
    return enroll.definition.url + queryParams(options)
}

/**
* @see \App\Domain\OrganizationAccess\Presentation\Http\Controllers\OrgMfaEnrollmentController::enroll
* @see app/Domain/OrganizationAccess/Presentation/Http/Controllers/OrgMfaEnrollmentController.php:21
* @route 'https://org.proexpert.app/org/mfa/enroll'
*/
enroll.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: enroll.url(options),
    method: 'get',
})

/**
* @see \App\Domain\OrganizationAccess\Presentation\Http\Controllers\OrgMfaEnrollmentController::enroll
* @see app/Domain/OrganizationAccess/Presentation/Http/Controllers/OrgMfaEnrollmentController.php:21
* @route 'https://org.proexpert.app/org/mfa/enroll'
*/
enroll.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: enroll.url(options),
    method: 'head',
})

/**
* @see \App\Domain\OrganizationAccess\Presentation\Http\Controllers\OrgMfaEnrollmentController::enroll
* @see app/Domain/OrganizationAccess/Presentation/Http/Controllers/OrgMfaEnrollmentController.php:21
* @route 'https://org.proexpert.app/org/mfa/enroll'
*/
const enrollForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: enroll.url(options),
    method: 'get',
})

/**
* @see \App\Domain\OrganizationAccess\Presentation\Http\Controllers\OrgMfaEnrollmentController::enroll
* @see app/Domain/OrganizationAccess/Presentation/Http/Controllers/OrgMfaEnrollmentController.php:21
* @route 'https://org.proexpert.app/org/mfa/enroll'
*/
enrollForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: enroll.url(options),
    method: 'get',
})

/**
* @see \App\Domain\OrganizationAccess\Presentation\Http\Controllers\OrgMfaEnrollmentController::enroll
* @see app/Domain/OrganizationAccess/Presentation/Http/Controllers/OrgMfaEnrollmentController.php:21
* @route 'https://org.proexpert.app/org/mfa/enroll'
*/
enrollForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: enroll.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

enroll.form = enrollForm

/**
* @see \App\Domain\OrganizationAccess\Presentation\Http\Controllers\OrgMfaChallengeController::challenge
* @see app/Domain/OrganizationAccess/Presentation/Http/Controllers/OrgMfaChallengeController.php:21
* @route 'https://org.proexpert.app/org/mfa/challenge'
*/
export const challenge = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: challenge.url(options),
    method: 'get',
})

challenge.definition = {
    methods: ["get","head"],
    url: 'https://org.proexpert.app/org/mfa/challenge',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Domain\OrganizationAccess\Presentation\Http\Controllers\OrgMfaChallengeController::challenge
* @see app/Domain/OrganizationAccess/Presentation/Http/Controllers/OrgMfaChallengeController.php:21
* @route 'https://org.proexpert.app/org/mfa/challenge'
*/
challenge.url = (options?: RouteQueryOptions) => {
    return challenge.definition.url + queryParams(options)
}

/**
* @see \App\Domain\OrganizationAccess\Presentation\Http\Controllers\OrgMfaChallengeController::challenge
* @see app/Domain/OrganizationAccess/Presentation/Http/Controllers/OrgMfaChallengeController.php:21
* @route 'https://org.proexpert.app/org/mfa/challenge'
*/
challenge.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: challenge.url(options),
    method: 'get',
})

/**
* @see \App\Domain\OrganizationAccess\Presentation\Http\Controllers\OrgMfaChallengeController::challenge
* @see app/Domain/OrganizationAccess/Presentation/Http/Controllers/OrgMfaChallengeController.php:21
* @route 'https://org.proexpert.app/org/mfa/challenge'
*/
challenge.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: challenge.url(options),
    method: 'head',
})

/**
* @see \App\Domain\OrganizationAccess\Presentation\Http\Controllers\OrgMfaChallengeController::challenge
* @see app/Domain/OrganizationAccess/Presentation/Http/Controllers/OrgMfaChallengeController.php:21
* @route 'https://org.proexpert.app/org/mfa/challenge'
*/
const challengeForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: challenge.url(options),
    method: 'get',
})

/**
* @see \App\Domain\OrganizationAccess\Presentation\Http\Controllers\OrgMfaChallengeController::challenge
* @see app/Domain/OrganizationAccess/Presentation/Http/Controllers/OrgMfaChallengeController.php:21
* @route 'https://org.proexpert.app/org/mfa/challenge'
*/
challengeForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: challenge.url(options),
    method: 'get',
})

/**
* @see \App\Domain\OrganizationAccess\Presentation\Http\Controllers\OrgMfaChallengeController::challenge
* @see app/Domain/OrganizationAccess/Presentation/Http/Controllers/OrgMfaChallengeController.php:21
* @route 'https://org.proexpert.app/org/mfa/challenge'
*/
challengeForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: challenge.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

challenge.form = challengeForm

/**
* @see \App\Domain\OrganizationAccess\Presentation\Http\Controllers\OrgMfaEnrollmentController::recovery
* @see app/Domain/OrganizationAccess/Presentation/Http/Controllers/OrgMfaEnrollmentController.php:87
* @route 'https://org.proexpert.app/org/mfa/recovery'
*/
export const recovery = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: recovery.url(options),
    method: 'get',
})

recovery.definition = {
    methods: ["get","head"],
    url: 'https://org.proexpert.app/org/mfa/recovery',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Domain\OrganizationAccess\Presentation\Http\Controllers\OrgMfaEnrollmentController::recovery
* @see app/Domain/OrganizationAccess/Presentation/Http/Controllers/OrgMfaEnrollmentController.php:87
* @route 'https://org.proexpert.app/org/mfa/recovery'
*/
recovery.url = (options?: RouteQueryOptions) => {
    return recovery.definition.url + queryParams(options)
}

/**
* @see \App\Domain\OrganizationAccess\Presentation\Http\Controllers\OrgMfaEnrollmentController::recovery
* @see app/Domain/OrganizationAccess/Presentation/Http/Controllers/OrgMfaEnrollmentController.php:87
* @route 'https://org.proexpert.app/org/mfa/recovery'
*/
recovery.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: recovery.url(options),
    method: 'get',
})

/**
* @see \App\Domain\OrganizationAccess\Presentation\Http\Controllers\OrgMfaEnrollmentController::recovery
* @see app/Domain/OrganizationAccess/Presentation/Http/Controllers/OrgMfaEnrollmentController.php:87
* @route 'https://org.proexpert.app/org/mfa/recovery'
*/
recovery.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: recovery.url(options),
    method: 'head',
})

/**
* @see \App\Domain\OrganizationAccess\Presentation\Http\Controllers\OrgMfaEnrollmentController::recovery
* @see app/Domain/OrganizationAccess/Presentation/Http/Controllers/OrgMfaEnrollmentController.php:87
* @route 'https://org.proexpert.app/org/mfa/recovery'
*/
const recoveryForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: recovery.url(options),
    method: 'get',
})

/**
* @see \App\Domain\OrganizationAccess\Presentation\Http\Controllers\OrgMfaEnrollmentController::recovery
* @see app/Domain/OrganizationAccess/Presentation/Http/Controllers/OrgMfaEnrollmentController.php:87
* @route 'https://org.proexpert.app/org/mfa/recovery'
*/
recoveryForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: recovery.url(options),
    method: 'get',
})

/**
* @see \App\Domain\OrganizationAccess\Presentation\Http\Controllers\OrgMfaEnrollmentController::recovery
* @see app/Domain/OrganizationAccess/Presentation/Http/Controllers/OrgMfaEnrollmentController.php:87
* @route 'https://org.proexpert.app/org/mfa/recovery'
*/
recoveryForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: recovery.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

recovery.form = recoveryForm

const mfa = {
    enroll: Object.assign(enroll, enroll47ba96),
    challenge: Object.assign(challenge, challengeF9272e),
    recovery: Object.assign(recovery, recoveryA63da9),
}

export default mfa